import { type MenuItemProps, Tab } from '@mairistem/composants';
import { getMenuItem } from '@mairistem/finances-utils';
import React from 'react';
import TypePeriode from '../../../../constants/simulation/typePeriode';
import type OutilModalProps from '../../../../interfaces/simulation/outilModalProps';
import ExportExcel from './ExportExcel';
import ImportExcel from './ImportExcel';
import './ImportExportExcelMenu.css';

const ImportExportExcelMenu = ({
	onValidate,
	simulation,
}: Pick<OutilModalProps, 'onValidate' | 'simulation'>) => {
	const [loading, setLoading] = React.useState<boolean>(false);

	const PANES = [
		{
			menuItem: (_, props: MenuItemProps) =>
				getMenuItem({
					...props,
					content: 'Exporter les données',
					'data-testid': 'exportExcelMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ExportExcel simulation={simulation} />
				</Tab.Pane>
			),
		},
		simulation?.typePeriode === TypePeriode.PROPOSE && {
			menuItem: (_, props: MenuItemProps) =>
				getMenuItem({
					...props,
					content: 'Importer des données',
					'data-testid': 'importExcelMenu',
				}),
			render: () => (
				<Tab.Pane loading={loading}>
					<ImportExcel
						loading={loading}
						onValidate={onValidate}
						setLoading={setLoading}
						simulation={simulation}
					/>
				</Tab.Pane>
			),
		},
	];

	return (
		<Tab
			className="importExportExcelMenu"
			menu={{
				pointing: true,
				secondary: true,
				vertical: true,
			}}
			panes={PANES}
		/>
	);
};

export default ImportExportExcelMenu;
